<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">{{ titulo }} Equipos</h1>
                <v-layout align-center>
                    <v-flex>
                        <router-link exact :to="'/presupuesto/' + presup" class="display-1">Presupuesto Nº {{ presup
                            }}
                        </router-link>
                    </v-flex>
                    <v-flex xs2>
                        <revisiones @change="revisionMostrar()" v-model="revision" :id.sync="d.id"></revisiones>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <empresa-select v-model="d.empresa_id" validate="required"></empresa-select>
            </v-flex>
            <v-flex>
                <ubicacion-select v-model="d.ubicacion" validate="required"></ubicacion-select>
            </v-flex>
            <v-flex>
                <v-text-field v-model="d.plazo_entrega" label="Plazo de entrega en días" validate="required"></v-text-field>
<!--                <v-menu-->
<!--                        ref="menuFechaEntrega"-->
<!--                        :close-on-content-click="false"-->
<!--                        v-model="menuFechaEntrega"-->
<!--                        :nudge-right="40"-->
<!--                        :return-value.sync="d.fecha_entrega"-->
<!--                        lazy-->
<!--                        transition="scale-transition"-->
<!--                        offset-y-->
<!--                        full-width-->
<!--                        min-width="290px"-->
<!--                >-->
<!--                    <v-text-field-->
<!--                            slot="activator"-->
<!--                            v-model="d.fecha_entrega"-->
<!--                            label="Fecha de Entrega"-->
<!--                            prepend-icon="event"-->
<!--                            readonly-->
<!--                            persistent-hint-->
<!--                            clearable-->
<!--                            hint="Fecha negociada entre la empresa y el cliente"-->
<!--                            :error-messages="errores.collect('fecha_entrega')"-->
<!--                            v-validate="'required'"-->
<!--                            data-vv-name="fecha_entrega"-->
<!--                            required-->

<!--                    ></v-text-field>-->
<!--                    <v-date-picker v-model="d.fecha_entrega" scrollable locale="es-sp">-->
<!--                        <v-spacer></v-spacer>-->
<!--                        <v-btn flat color="error" @click="menuFechaEntrega = false">Cancelar</v-btn>-->
<!--                        <v-btn flat color="success" @click="$refs.menuFechaEntrega.save(d.fecha_entrega)">Confirmar</v-btn>-->
<!--                    </v-date-picker>-->
<!--                </v-menu>-->
            </v-flex>
            <v-flex>
                <v-checkbox label="¿Para stock?" v-model="d.stock"></v-checkbox>
            </v-flex>
        </v-layout>

        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-text>
                        <h3>Equipo</h3>
                        <v-layout row wrap>
                            <v-flex>
                                <item-select
                                        v-model="item"
                                        :id.sync="d.item_id"
                                        :tipo="4"
                                        required
                                        :preset="item"
                                        @input="traePrecio(d.item_id,'pu')"
                                ></item-select>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="d.cant" label="Cantidad"
                                              :error-messages="errores.collect('cant')"
                                              v-validate="'required|mayor'"
                                              data-vv-name="cant"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Precio Unitario"
                                        readonly
                                        v-model="pu"
                                        :suffix="moneda.signo"
                                        :error-messages="errores.collect('pu')"
                                        v-validate="'required'"
                                        type="text"
                                        data-vv-name="pu"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Precio unit orig"
                                        readonly
                                        :value="d.pu_orig"
                                        :suffix="moneda.signo"
                                        type="text"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex>
                                <v-text-field
                                        label="Descuento comercial"
                                        v-model="d.descuento_com"
                                        prefix="%"
                                        :error-messages="errores.collect('descuento_com')"
                                        v-validate="{descuento_com:[d.item_id,id]}"
                                        data-vv-name="descuento_com"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Descuento estratégico"
                                        v-model="d.descuento_est"
                                        prefix="%"
                                        :error-messages="errores.collect('descuento_est')"
                                        v-validate="{descuento_est:[d.item_id,id]}"
                                        data-vv-name="descuento_est"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="d.espesor_panel" label="Espesor panel"
                                              suffix="MM"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12 sm3>
                                <v-text-field v-model="subtotEquipo" readonly label="Subtotal"
                                              :suffix="moneda.signo"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <br>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-text>
                        <h3>Comando</h3>
                        <v-layout row wrap>
                            <v-flex>
                                <item-select
                                        label="Comando"
                                        v-model="comando"
                                        :id.sync="d.comando_id"
                                        :tipo="4"
                                        :preset="comando"
                                        @input="traePrecio(d.comando_id,'comando_pu')"
                                ></item-select>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="d.comando_cant" label="Cantidad"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Precio Unitario"
                                        readonly
                                        v-model="comando_pu"
                                        :suffix="moneda.signo"
                                        :error-messages="errores.collect('comando_pu')"
                                        v-validate="'required'"
                                        type="text"
                                        data-vv-name="comando_pu"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Precio unit orig"
                                        readonly
                                        :value="d.comando_pu_orig"
                                        :suffix="moneda.signo"
                                        type="text"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex>
                                <v-text-field
                                        label="Descuento comercial"
                                        v-model="d.comando_descuento_com"
                                        prefix="%"
                                        :error-messages="errores.collect('comando_descuento_com')"
                                        v-validate="{descuento_com:[d.comando_id,id]}"
                                        data-vv-name="comando_descuento_com"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Descuento estratégico"
                                        v-model="d.comando_descuento_est"
                                        prefix="%"
                                        :error-messages="errores.collect('comando_descuento_est')"
                                        v-validate="{descuento_est:[d.comando_id,id]}"
                                        data-vv-name="comando_descuento_est"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="subtotComando" readonly label="Subtotal"
                                              :suffix="moneda.signo"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <br>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-text>
                        <h3>Kit</h3>
                        <v-layout row wrap>
                            <v-flex>
                                <item-select
                                        label="Kit"
                                        v-model="kit"
                                        :id.sync="d.kit_id"
                                        :tipo="4"
                                        :preset="kit"
                                        @input="traePrecio(d.kit_id,'kit_pu')"
                                ></item-select>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="d.kit_cant" label="Cantidad"></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Precio Unitario"
                                        readonly
                                        v-model="kit_pu"
                                        :suffix="moneda.signo"
                                        :error-messages="errores.collect('kit_pu')"
                                        v-validate="'required'"
                                        type="text"
                                        data-vv-name="kit_pu"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Precio unit orig"
                                        readonly
                                        :value="d.kit_pu_orig"
                                        :suffix="moneda.signo"
                                        type="text"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex>
                                <v-text-field
                                        label="Descuento comercial"
                                        v-model="d.kit_descuento_com"
                                        prefix="%"
                                        :error-messages="errores.collect('kit_descuento_com')"
                                        v-validate="{descuento_com:[d.kit_id,id]}"
                                        data-vv-name="kit_descuento_com"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field
                                        label="Descuento estratégico"
                                        v-model="d.kit_descuento_est"
                                        prefix="%"
                                        :error-messages="errores.collect('kit_descuento_est')"
                                        v-validate="{descuento_est:[d.kit_id,id]}"
                                        data-vv-name="kit_descuento_est"
                                ></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field v-model="subtotKit" readonly label="Subtotal"
                                              :suffix="moneda.signo"></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <br>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 md2>
                                <v-text-field v-model="subtotal" readonly label="Subtotal"
                                              :suffix="moneda.signo"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-textarea label="Observaciones" v-model="d.obs" counter="100"
                                            :error-messages="errores.collect('obs')"
                                            v-validate="'max:100'"
                                            data-vv-name="obs"
                                ></v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" dark :to="'/presupuesto/' + presup">CANCELAR</v-btn>
                        <v-btn color="green" dark @click.native="guardar" :loading="loading">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <tabla-items tipo="equ" :presup="presup" :moneda="moneda.id" ref="tabla"></tabla-items>
    </v-container>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import empresaSelect from '../../../components/EmpresaSelect';
    import ubicacionSelect from '../../../components/UbicacionSelect';
    import revisiones from '../../../components/Revisiones';
    import ItemSelect from '../../../components/ItemSelect';
    import mixinPresupItem from '../../../mixins/presupuestoItems';
    import mixinItems from '../../../mixins/items';
    import mixinPresupuesto from '../../../mixins/presupuesto';
    import mixinPrecio from '../../../mixins/precios';
    import tablaItems from '../../../components/TablaItems';
    import moneda from '../../../filters/moneda';

    function getInitialData() {
        return {
            item_id: '',
            item_tipo_id: '4',
            cant: 0,
            pu: 0,
            pu_orig: 0,
            subtotal: 0,
            obs: '',
            comando_id: '',
            comando_cant: 0,
            comando_pu: 0,
            comando_pu_orig: 0,
            comando_descuento_com: 0,
            comando_descuento_est: 0,
            kit_id: '',
            kit_cant: 0,
            kit_pu: 0,
            kit_pu_orig: 0,
            kit_descuento_com: 0,
            kit_descuento_est: 0,
            presupuesto_id: '',
            empresa_id: '',
            ubicacion: '',
            stock: false,
            espesor_panel: 0,
            fecha_entrega: '',
            plazo_entrega: ''
        }
    }

    export default {
        name: "add",
        $_veeValidate: {
            validator: 'new'
        },
        components: {ItemSelect, tablaItems, empresaSelect, ubicacionSelect, revisiones},
        mixins: [mixinPresupItem, mixinItems, mixinPresupuesto, mixinPrecio],
        filters: {moneda},
        data() {
            return {
                menuFechaEntrega: false,
                revision: '',
                item: {},
                comando: {},
                kit: {},
                moneda: {signo: '', id: ''},
                loading: false,
                descuento_est_monto: 0,
                descuento_com_monto: 0,
                comando_descuento_est_monto: 0,
                comando_descuento_com_monto: 0,
                kit_descuento_est_monto: 0,
                kit_descuento_com_monto: 0,
                d: getInitialData(),
            }
        },
        computed: {
            ...mapState({
                presup: state => state.route.params.presup,
                oper: state => state.route.params.oper,
                id: state => state.route.params.id,
            }),
            titulo() {
                return (this.oper === 'add') ? 'Agregar' : 'Editar';
            },
            pu() {
                let subtot = this.d.pu_orig;
                if (this.d.descuento_com) {
                    this.descuento_com_monto = (subtot / 100) * this.d.descuento_com;
                    subtot = subtot - this.descuento_com_monto;
                }

                if (this.d.descuento_est) {
                    this.descuento_est_monto = (subtot / 100) * this.d.descuento_est;
                    subtot = subtot - this.descuento_est_monto;
                }

                this.d.pu = subtot;
                return new Intl.NumberFormat('es-AR').format(this.d.pu);
            },
            comando_pu() {
                let subtot = this.d.comando_pu_orig;
                if (this.d.comando_descuento_com) {
                    this.comando_descuento_com_monto = (subtot / 100) * this.d.comando_descuento_com;
                    subtot = subtot - this.comando_descuento_com_monto;
                }

                if (this.d.comando_descuento_est) {
                    this.comando_descuento_est_monto = (subtot / 100) * this.d.comando_descuento_est;
                    subtot = subtot - this.comando_descuento_est_monto;
                }

                this.d.comando_pu = subtot;
                return new Intl.NumberFormat('es-AR').format(this.d.comando_pu);
            },
            kit_pu() {
                let subtot = this.d.kit_pu_orig;
                if (this.d.kit_descuento_com) {
                    this.kit_descuento_com_monto = (subtot / 100) * this.d.kit_descuento_com;
                    subtot = subtot - this.kit_descuento_com_monto;
                }

                if (this.d.kit_descuento_est) {
                    this.kit_descuento_est_monto = (subtot / 100) * this.d.kit_descuento_est;
                    subtot = subtot - this.kit_descuento_est_monto;
                }

                this.d.kit_pu = subtot;
                return new Intl.NumberFormat('es-AR').format(this.d.kit_pu);
            },
            subtotEquipo() {
                let r = this.d.pu * this.d.cant;
                return new Intl.NumberFormat('es-AR').format(r);
            },
            subtotComando() {
                let r = this.d.comando_pu * this.d.comando_cant;
                return new Intl.NumberFormat('es-AR').format(r);
            },
            subtotKit() {
                let r = this.d.kit_pu * this.d.kit_cant;
                return new Intl.NumberFormat('es-AR').format(r);
            },
            subtotal() {
                let sbtot = this.d.pu * this.d.cant;
                let sbtotC = this.d.comando_pu * this.d.comando_cant;
                let sbtotK = this.d.kit_pu * this.d.kit_cant;
                let subtotal = sbtot + sbtotC + sbtotK;
                this.d.subtotal = subtotal;
                return new Intl.NumberFormat('es-AR').format(subtotal);
            },
            total() {
                if (!this.items) {
                    return 0
                }
                return this.items.reduce((a, b) => {
                    return a + b.subtotal
                }, 0)
            }
        },
        mounted() {
            this.traeMoneda();
            this.traeDatos();
            this.d.presupuesto_id = this.$store.state.route.params.presup
        },
        watch: {
            '$route': 'traeDatos',
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            limpiar() {
                this.d = getInitialData();
                this.d.presupuesto_id = this.$store.state.route.params.presup;
                this.item = '';
                this.comando = '';
                this.kit = '';
                this.$validator.reset();
            },
            traePlazo() {
                this.presupuestoPlazo({presupuesto_id: this.d.presupuesto_id}, r => {
                    this.d.plazo_entrega = r;
                },err=>{
                    this.msjShow({txt: 'Error al obtener plazo', tipo: 'error'});
                })
            },
            traeDatos() {
                if (this.oper !== 'edit') {
                    this.traePlazo();
                    return false;
                }
                this.loading = true;
                this.presupuestoItemShow(this.id, r => {
                    this.d = r;
                    this.item = r.item;
                    this.comando = r.comando;
                    this.kit = r.kit;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                })
            },
            traePrecio(item, campo) {
                if (!this.item) {
                    return false;
                }
                this.precioBusqueda({
                    producto: item,
                    empresa: this.d.empresa_id,
                    item_tipo_id: this.d.item_tipo_id
                }, r => {
                    this.d[campo] = (r) ? r : 0;
                    this.d[campo + '_orig'] = (r) ? r : 0;
                }, err => {
                    console.log(err);
                })
            },
            traeMoneda() {
                this.presupuestoMoneda({presupuesto_id: this.presup}, r => {
                    this.moneda = r;
                }, err => {
                    console.log(err)
                })
            },
            guardar() {
                if (!this.d.presupuesto_id) {
                    this.msjShow({txt: 'Falta numero de presupuesto', tipo: 'error'});
                    return false;
                }
                this.$validator.validateAll()
                    .then(r => {
                        if (r) {
                            this.loading = true;
                            if (this.oper === 'edit') {
                                this.presupuestoItemUpdate(this.d, r => {
                                    this.msjShow(r);
                                    this.limpiar();
                                    this.loading = false;
                                    this.$refs.tabla.getItems();
                                    this.$router.push('/presupuesto/' + this.presup);
                                }, e => {
                                    this.msjShow({
                                        txt: 'Error de validación',
                                        tipo: 'error',
                                        errores: (e.errors) ? e.errors : ''
                                    });
                                    this.loading = false;
                                })
                            } else {
                                this.presupuestoItemStore(this.d, r => {
                                    this.msjShow(r);
                                    this.limpiar();
                                    this.loading = false;
                                    this.$refs.tabla.getItems();
                                }, e => {
                                    this.msjShow({
                                        txt: 'Error de validación',
                                        tipo: 'error',
                                        errores: (e.errors) ? e.errors : ''
                                    });
                                    this.loading = false;
                                })
                            }

                        }

                    })
            },
            revisionMostrar() {
                if (this.d.id) {
                    this.loading = true;
                    this.presupuestoItemRevisionShow({id: this.d.id, revision: this.revision}, r => {
                        this.d = r;
                        this.item = r.item;
                        this.loading = false;
                    })
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/presup/item/equ.vue